// src/transactions/TransactionForm.js
import React from "react";
import {
  Create,
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  FileInput,
  FileField,
  FunctionField,
} from "react-admin";

import saveTransaction from "./transactionSave";

export const TransactionCreate = () => (
  <Create>
    <SimpleForm onSubmit={saveTransaction}>
      <ReferenceInput source="accountId" reference="accounts" label="Account Head">
        <SelectInput optionText="name" />
      </ReferenceInput>

      <DateInput
        source="date"
        InputProps={{ onClick: (e) => e.target.showPicker && e.target.showPicker() }}
      />

      <TextInput source="expenseType" label="Type" />
      <TextInput source="description" />
      <NumberInput source="amountIn" label="Amount In" />
      <NumberInput source="amountOut" label="Amount Out" />
      <TextInput source="paidBy" label="Paid By" />
      <TextInput source="comment" label="Comment" />

      <FileInput
        source="proofFile"
        label="Upload Bill/Proof"
        accept="image/*,.pdf"
      >
        <FileField source="src" title="title" />
      </FileInput>
    </SimpleForm>
  </Create>
);

export const TransactionEdit = () => (
  <Edit>
    <SimpleForm onSubmit={saveTransaction}>
      <ReferenceInput source="accountId" reference="accounts" label="Account Head">
        <SelectInput optionText="name" />
      </ReferenceInput>

      <DateInput
        source="date"
        InputProps={{ onClick: (e) => e.target.showPicker && e.target.showPicker() }}
      />

      <TextInput source="expenseType" label="Type" />
      <TextInput source="description" />
      <NumberInput source="amountIn" label="Amount In" />
      <NumberInput source="amountOut" label="Amount Out" />
      <NumberInput source="balance" label="Running Balance" />
      <TextInput source="paidBy" label="Paid By" />
      <TextInput source="comment" label="Comment" />

      <FileInput
        source="proofFile"
        label="Replace Bill/Proof"
        accept="image/*,.pdf"
      >
        <FileField source="src" title="title" />
      </FileInput>

      <FunctionField
        label="Existing Proof"
        render={(record) =>
          record?.proofUrl ? (
            <a
              href={record.proofUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1976d2" }}
            >
              View current file
            </a>
          ) : (
            "No file uploaded"
          )
        }
      />
    </SimpleForm>
  </Edit>
);
